module.exports = __webpack_public_path__ + "static/img/testimony (12).f1c790b7.jpg";